/* ga-lightbox.js — in-page image viewer for links marked data-ga-lightbox (2026-10-19).
   No libraries. Native <dialog> (top layer, focus containment, Escape) plus:
   - pinch-zoom, double-tap / double-click zoom, wheel and +/- zoom, drag to pan
   - swipe (at normal size), arrow keys and buttons to move between images in a group
   - tap/click on the dark background closes; the background never scrolls while open and
     the visitor's exact scroll position (and focus) is restored on close.
   Ctrl/Cmd/Shift/middle-click on a link keeps the browser's own behavior. */
(function () {
  var dlg = document.querySelector('[data-ga-lb]');
  if (!dlg || typeof dlg.showModal !== 'function') return; // no <dialog> support: links stay plain links

  var stage = dlg.querySelector('[data-ga-lb-stage]');
  var img = dlg.querySelector('[data-ga-lb-img]');
  var countEl = dlg.querySelector('[data-ga-lb-count]');
  var ofWord = dlg.getAttribute('data-of') || 'of';
  var MAX = 4, STEP = 1.6, DBL_MS = 350;

  var group = [], index = 0, opener = null, scrollX = 0, scrollY = 0;
  var s = 1, tx = 0, ty = 0;          // current zoom and pan
  var pointers = new Map();
  var gesture = null;                  // {type, ...} for the active drag/pinch
  var lastTap = 0, lastTapX = 0, lastTapY = 0, moved = false;

  function links(name) {
    return Array.prototype.slice.call(document.querySelectorAll('a[data-ga-lightbox="' + name + '"]'));
  }

  /* ---------- transform ---------- */
  function base() {
    // untransformed layout box of the image (offsetLeft/Top are relative to the stage)
    return { l: img.offsetLeft, t: img.offsetTop, w: img.offsetWidth, h: img.offsetHeight };
  }
  function clamp() {
    var b = base(), vw = stage.clientWidth, vh = stage.clientHeight, W = b.w * s, H = b.h * s;
    if (W <= vw) tx = (vw - W) / 2 - b.l; else tx = Math.min(-b.l, Math.max(vw - b.l - W, tx));
    if (H <= vh) ty = (vh - H) / 2 - b.t; else ty = Math.min(-b.t, Math.max(vh - b.t - H, ty));
  }
  function apply(animate) {
    if (s <= 1.001) { s = 1; tx = 0; ty = 0; } else clamp();
    dlg.classList.toggle('is-animating', !!animate);
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
    dlg.classList.toggle('is-zoomed', s > 1);
  }
  function zoomAt(ns, cx, cy, animate) {
    ns = Math.max(1, Math.min(MAX, ns));
    var r = stage.getBoundingClientRect(), b = base();
    var px = cx - r.left, py = cy - r.top;              // point in stage coords
    var lx = (px - b.l - tx) / s, ly = (py - b.t - ty) / s; // same point in image coords
    tx = px - b.l - lx * ns; ty = py - b.t - ly * ns; s = ns;
    apply(animate);
  }
  function center() { var r = stage.getBoundingClientRect(); return [r.left + r.width / 2, r.top + r.height / 2]; }
  function reset(animate) { s = 1; tx = 0; ty = 0; apply(animate); }

  /* ---------- content ---------- */
  function show(i) {
    index = (i + group.length) % group.length;
    var a = group[index];
    var full = a.getAttribute('data-ga-lightbox-src') || a.href;
    var thumb = a.querySelector('img');
    reset(false);
    img.alt = a.getAttribute('data-ga-lightbox-alt') || (thumb && thumb.alt) || '';
    if (a.getAttribute('data-ga-lightbox-w')) { img.width = +a.getAttribute('data-ga-lightbox-w'); img.height = +a.getAttribute('data-ga-lightbox-h'); }
    // Show the already-loaded page image instantly, then swap in the full-size file.
    if (thumb && thumb.currentSrc && thumb.complete) img.src = thumb.currentSrc;
    var hi = new Image();
    hi.onload = function () { if (group[index] === a) img.src = full; };
    hi.src = full;
    countEl.textContent = group.length > 1 ? (index + 1) + ' ' + ofWord + ' ' + group.length : '';
    dlg.classList.toggle('is-single', group.length < 2);
    if (group.length > 1) { var n = new Image(); n.src = group[(index + 1) % group.length].getAttribute('data-ga-lightbox-src') || group[(index + 1) % group.length].href; }
  }
  function go(d) {
    if (group.length < 2) return;
    dlg.classList.add('is-switching');
    setTimeout(function () { show(index + d); dlg.classList.remove('is-switching'); }, 110);
  }

  /* ---------- open / close ---------- */
  function lock() {
    scrollX = window.scrollX; scrollY = window.scrollY;
    var sbw = window.innerWidth - document.documentElement.clientWidth; // keep layout width (no shift)
    document.documentElement.classList.add('ga-lb-lock');
    document.body.style.top = (-scrollY) + 'px';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }
  function unlock() {
    document.documentElement.classList.remove('ga-lb-lock');
    document.body.style.top = ''; document.body.style.paddingRight = '';
    var html = document.documentElement, prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(scrollX, scrollY);
    html.style.scrollBehavior = prev;
  }
  function open(a) {
    opener = a;
    group = links(a.getAttribute('data-ga-lightbox'));
    lock();
    dlg.showModal();
    show(Math.max(0, group.indexOf(a)));
    dlg.querySelector('[data-ga-lb-close]').focus({ preventScroll: true });
  }
  function close() {
    if (!dlg.open) return;
    dlg.close();
  }
  dlg.addEventListener('close', function () {
    pointers.clear(); gesture = null;
    unlock();
    img.removeAttribute('src');
    if (opener) opener.focus({ preventScroll: true });
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); }); // Escape

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-ga-lightbox]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    open(a);
  });

  /* ---------- controls ---------- */
  dlg.querySelector('[data-ga-lb-close]').addEventListener('click', close);
  Array.prototype.forEach.call(dlg.querySelectorAll('[data-ga-lb-nav]'), function (b) {
    b.addEventListener('click', function () { go(+b.getAttribute('data-ga-lb-nav')); });
  });
  Array.prototype.forEach.call(dlg.querySelectorAll('[data-ga-lb-zoom]'), function (b) {
    b.addEventListener('click', function () {
      var c = center();
      zoomAt(b.getAttribute('data-ga-lb-zoom') === 'in' ? s * STEP : s / STEP, c[0], c[1], true);
    });
  });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    else if (e.key === '+' || e.key === '=') { var c = center(); zoomAt(s * STEP, c[0], c[1], true); }
    else if (e.key === '-' || e.key === '_') { var d = center(); zoomAt(s / STEP, d[0], d[1], true); }
    else if (e.key === '0') reset(true);
  });

  /* ---------- gestures ---------- */
  function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
  stage.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    try { stage.setPointerCapture(e.pointerId); } catch (err) { /* pointer already released */ }
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 1) {
      moved = false;
      gesture = { type: s > 1 ? 'pan' : 'swipe', x: e.clientX, y: e.clientY, tx: tx, ty: ty, onImg: e.target === img };
      if (s > 1) dlg.classList.add('is-dragging');
    } else if (pointers.size === 2) {
      var p = Array.from(pointers.values());
      gesture = { type: 'pinch', d: dist(p[0], p[1]), s: s };
      moved = true;
    }
  });
  stage.addEventListener('pointermove', function (e) {
    if (!pointers.has(e.pointerId) || !gesture) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (gesture.type === 'pinch' && pointers.size >= 2) {
      var p = Array.from(pointers.values());
      var mx = (p[0].x + p[1].x) / 2, my = (p[0].y + p[1].y) / 2;
      zoomAt(gesture.s * dist(p[0], p[1]) / gesture.d, mx, my, false);
    } else if (gesture.type === 'pan') {
      var dx = e.clientX - gesture.x, dy = e.clientY - gesture.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
      tx = gesture.tx + dx; ty = gesture.ty + dy; apply(false);
    } else if (gesture.type === 'swipe') {
      var sx = e.clientX - gesture.x;
      if (Math.abs(sx) + Math.abs(e.clientY - gesture.y) > 8) moved = true;
      if (group.length > 1) img.style.transform = 'translate(' + sx * 0.6 + 'px,0)';
    }
  });
  function end(e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.delete(e.pointerId);
    dlg.classList.remove('is-dragging');
    if (!gesture) return;
    if (gesture.type === 'pinch') {
      if (pointers.size === 1) { // continue as a pan with the remaining finger
        var p = Array.from(pointers.values())[0];
        gesture = { type: 'pan', x: p.x, y: p.y, tx: tx, ty: ty };
      } else { gesture = null; apply(true); }
      return;
    }
    if (pointers.size) return;
    var g = gesture; gesture = null;
    if (g.type === 'swipe') {
      var dx = e.clientX - g.x, dy = e.clientY - g.y;
      if (group.length > 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) { go(dx < 0 ? 1 : -1); return; }
      apply(true); // snap back
    }
    if (moved || e.type === 'pointercancel') return;
    // a tap / click
    var now = Date.now();
    var dbl = now - lastTap < DBL_MS && Math.abs(e.clientX - lastTapX) < 30 && Math.abs(e.clientY - lastTapY) < 30;
    lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
    if (dbl) { lastTap = 0; if (s > 1) reset(true); else zoomAt(2.5, e.clientX, e.clientY, true); return; }
    if (g.onImg === false && s === 1) {
      // tap on the dark background closes (after the double-tap window, so a double-tap can still zoom)
      var t = now;
      setTimeout(function () { if (lastTap === t) close(); }, DBL_MS - 40);
    }
  }
  stage.addEventListener('pointerup', end);
  stage.addEventListener('pointercancel', end);
  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    var f = Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0025)); // ctrlKey = trackpad pinch
    zoomAt(s * f, e.clientX, e.clientY, false);
  }, { passive: false });
  window.addEventListener('resize', function () { if (dlg.open) apply(false); });
})();
